import { render, staticRenderFns } from "./CropPlanner.vue?vue&type=template&id=0f9d52c3&scoped=true&"
import script from "./CropPlanner.vue?vue&type=script&lang=js&"
export * from "./CropPlanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f9d52c3",
  null
  
)

export default component.exports